export default __webpack_public_path__ + "static/unicorn-lego-man-df48eb92a05a654bb777615fb713b97e.webp";